import { WinampLogoFilled } from "@winamp/icons/WinampLogoFilled.js";
import { classNames } from "@winamp/ui/utils/classNames.js";
import type { ComponentProps } from "react";

export function CoverPlaceholder({
  className,
  ...props
}: ComponentProps<"div">) {
  return (
    <div
      className={classNames(
        "size-10 flex shrink-0 items-center justify-center bg-secondary rounded-md",
        className,
      )}
      {...props}
    >
      <WinampLogoFilled className="size-1/2 text-tertiary" />
    </div>
  );
}
